<template>
	<div>
		<div class="head">
			<div class="logo" @click="url('/')">
				<img :src="config.logo">
			</div>
			<div class="menu"  @click="drawer = true">
				<img src="@/static/image/menu.png">
			</div>
		</div>

		<el-drawer size="200px" title="导航菜单" :visible.sync="drawer" direction="rtl">
			<div class="nav">
				<li v-for="(item,index) in data" :key="index">
					<a class="item" :class="active==index?'active':''" href="javascript:;" @click="url(item.href)">
						{{item.name}}
					</a>
				</li>
			</div>
		</el-drawer>

		<div class="search">
			<input type="text" v-model="keyword" class="search-input" @change="search" @input="search" placeholder="请输入搜索关键词">
			<i class="el-icon-search search-icon"></i>
		</div>
	</div>
</template>

<script>
	import {
		common_nav,
		common_config
	} from '@/api/common.js';
	export default {
		name: 'commonHead',
		props: {
			active: 0,
		},

		data() {
			return {
				config: {},
				data: [],
				keyword: '',
				drawer: false,
			}
		},
		mounted() {
			this.keyword = this.$route.query.keyword;
		},
		created() {
			this.get_data();
			this.get_config();
		},
		methods: {
			get_data() {
				common_nav({
					nav_id: 1
				}).then(res => {
					if (res.code == 1) {
						this.data = res.data;
					}
				});
			},
			get_config() {
				common_config({}).then(res => {
					if (res.code == 1) {
						this.config = res.data;
					}
				});
			},
			url(path) {
				window.location.href = path;
			},

			//搜索
			search(e) {
				var keyword = e.target.value;
				if (this.$route.path == '/search') {
					this.$emit('search', keyword);
				} else {
					this.$router.push('/search?keyword=' + keyword);
				}
			},


		}
	}
</script>
<style lang="less" scoped>
	.head {
		height: 50px;
		width: 100%;
		position: relative;
	}

	.logo {
		height: 50px;
		position: absolute;
		left: 0;
		top: 0;
		text-align: center;
		line-height: 50px;
	}

	.logo img {
		height: 30px;
		margin-top: 15px;
		margin-left: 15px;
	}

	.menu {
		position: absolute;
		right: 15px;
		top: 0;
		height: 50px;
	}

	.menu img {
		height: 30px;
		margin-top: 10px;
	}


	.search {
		padding:5px 15px 15px;
		width: calc(100% - 30px);
		line-height: 40px;
		height: 40px;
	}

	.search-input {
		width: calc(100% - 15px);
		height: 30px;
		border: none;
		background-color: #fff;
		border-radius: 15px;
		outline: none;
		padding-left: 15px;
	}

	.search-input:hover {
		border: none;
	}

	.search-icon {
		position: absolute;
		right: 25px;
		top: 64px;
		font-size: 26px;
		color: #aaa;
	}

	.nav li {
		list-style: none;
		color: #a0ca32;
	}

	.nav li a {
		color: #a0ca32;
		text-decoration: none;
		padding: 10px 15px;
		display: block;
	}

	.active {
		background: #a0ca32;
		color: #fff!important;
		font-weight: 600;
	}
</style>